import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserDashboard from './components/UserDashboard/UserDashboard';
import { BookingsProvider } from './components/UserDashboard/BookingContext';
import AdminDashboard from './components/AdminDashboard/AdminDashboard';
import EmptyDashboard from './components/EmptyDashboard/EmptyDashboard';

const Dashboard = (props) => {

  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();

  const initialDate =
    currentHour > 23 || (currentHour === 23 && currentMinute >= 45)
      ? new Date(currentDate.setDate(currentDate.getDate() + 1))
      : currentDate;

  const renderDashboard = () => {
    switch (props.userType) {
      case 'User':
        return (
          <BookingsProvider initUser={props.user} initialDate={initialDate}>
            <UserDashboard />
          </BookingsProvider>
        );
      case 'Admin':
        return <AdminDashboard />;
      case 'Breathe-Admin':
        return <AdminDashboard />;
      case 'Customer':
        if (props.access && props.access.dashboard) {
          return <AdminDashboard />;
        }
        else {
          return <EmptyDashboard />;
        }
      default:
        return <div>No Dashboard Available</div>;
    }
  };

  return <>{renderDashboard()}</>;
};

Dashboard.propTypes = {
  userType: PropTypes.string,
  user: PropTypes.object,
  access: PropTypes.object
};

const mapStateToProps = (state) => ({
  userType: state.auth && state.auth.user ? state.auth.user.type : null,
  user: state.auth && state.auth.user ? state.auth.user : null,
  access: state.auth && state.auth.user ? state.auth.user.access : null,
});

export default connect(mapStateToProps)(Dashboard);
